
// Toggle blog filter list in mobile view
document.querySelectorAll(".cdk-mobile-button").forEach(function (button) {
    button.addEventListener("click", function () {
        const blogFilterList = document.querySelector(".blog-filter-list-mobile");
        if (blogFilterList.style.display === "none" || !blogFilterList.style.display) {
            blogFilterList.style.display = "block";
        } else {
            blogFilterList.style.display = "none";
        }
    });
});

// Toggle custom article items in mobile view
document.querySelectorAll(".Custom_article-mobile-btn").forEach(function (button) {
    button.addEventListener("click", function () {
        const customArticleItem = document.querySelector(".custom-article-item");
        if (customArticleItem.style.display === "none" || !customArticleItem.style.display) {
            customArticleItem.style.display = "block";
        } else {
            customArticleItem.style.display = "none";
        }
    });
});

// Handle guide click events
document.querySelectorAll(".custom-article-guide .guide").forEach(function (guide) {
    guide.addEventListener("click", function (event) {
        event.preventDefault();
        var deviceWidth = window.innerWidth;
        var scrolldiv = guide.getAttribute("tab-scroll");

        if (deviceWidth <= 991) {
            document.querySelectorAll('.custom-article-guide .guide').forEach(function (item) {
                item.classList.remove("active");
            });
            guide.classList.add("active");
        }

        setTimeout(function () {
            var targetElement = document.querySelector(".image_with_text[tab-to-scroll='" + scrolldiv + "']");
            if (targetElement) {
                console.log(targetElement.offsetTop);
                window.scrollTo({
                    top: targetElement.offsetTop + 500,
                    behavior: "smooth"
                });
            }
        }, 200);
    });
});

// Scroll event to update the active class
window.addEventListener("scroll", function () {
    var deviceWidth = window.innerWidth;
    if (deviceWidth >= 992) {
        var scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
        document.querySelectorAll('.image_with_text').forEach(function (refElement) {
            var currLink = document.querySelector(".custom-article-guide .guide[tab-scroll='" + refElement.getAttribute("tab-to-scroll") + "']");
            if (currLink && refElement.offsetTop + 500 <= scrollPos && refElement.offsetTop + refElement.offsetHeight > scrollPos) {
                document.querySelectorAll('.custom-article-guide .guide').forEach(function (link) {
                    link.classList.remove("active");
                });
                currLink.classList.add("active");
            }
        });
    }
});

function relatedPostSlider() {
    const postsWrappper = document.querySelectorAll('.related_blog_main');
    postsWrappper.forEach(wrapper => {
        if (wrapper) {
        let id = wrapper.getAttribute('data-section-id');
        let swiperContainer = wrapper.querySelector('#related-slider-' + id);

        if (swiperContainer) {
            if (swiperContainer.swiper) {
            swiperContainer.swiper.destroy();
            }

            let swiperOptions = {
                slidesPerView: 1,
                spaceBetween: 20,
                navigation: {
                    nextEl: ".swiper-button-next.swiper-button-" + id,
                    prevEl: ".swiper-button-prev.swiper-button-" + id,
                },
                pagination: {
                    el: ".swiper-pagination-" + id + ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    769: {
                      slidesPerView: 2,
                      spaceBetween: 30,
                    },
                    993: {
                      slidesPerView: 3,
                      spaceBetween: 30,
                    },
                },
            };
            new Swiper('#related-slider-' + id, swiperOptions);
        }
        }
    });
}

function relatedProductsArticleSlider() {
    const productsWrappper = document.querySelectorAll('.article_featured_product');
    productsWrappper.forEach(wrapper => {
        if (wrapper) {
        let id = wrapper.getAttribute('data-section-id');
        let swiperContainer = wrapper.querySelector('#related-products-' + id);

        if (swiperContainer) {
            if (swiperContainer.swiper) {
            swiperContainer.swiper.destroy();
            }

            let swiperOptions = {
                slidesPerView: 1.1,
                spaceBetween: 16,
                navigation: {
                    nextEl: ".swiper-button-next.swiper-button-" + id,
                    prevEl: ".swiper-button-prev.swiper-button-" + id,
                },
                pagination: {
                    el: ".swiper-pagination-" + id + ".swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    769: {
                      slidesPerView: 3,
                    },
                },
            };
            new Swiper('#related-products-' + id, swiperOptions);
        }
        }
    });
}

document.addEventListener("DOMContentLoaded", function (event) {
    relatedPostSlider();
    relatedProductsArticleSlider();
});
